import { render, staticRenderFns } from "./entranceClient.vue?vue&type=template&id=4a6f8c6d&scoped=true"
import script from "./entranceClient.vue?vue&type=script&lang=js"
export * from "./entranceClient.vue?vue&type=script&lang=js"
import style0 from "./entranceClient.vue?vue&type=style&index=0&id=4a6f8c6d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a6f8c6d",
  null
  
)

export default component.exports